









import videojs from "video.js"
import "videojs-contrib-hls"
import "video.js/dist/video-js.css"
import { Vue, Component } from "vue-property-decorator";
@Component
export default class Mr100Index extends Vue {
  public videoPlayer: any;
  initVideo() {
    this.videoPlayer = videojs(
      "singleVideo",
      {
      textTrackDisplay: false,
      posterImage: true,
      errorDisplay: false,
      controlBar: {
        volumePanel: {
          inline: false,
          CurrentTimeDisplay: true
        }
      }
    }
    );
  }
  mounted() {
    this.initVideo();
  }
  beforeDestroy() {
    if (this.videoPlayer) {
      this.videoPlayer.dispose();
   }
  }
}
